export interface DevToken {
  key: string;
  name: string;
  token: string;
}

export const DEV_TOKENS: DevToken[] = [
  {
    key: 'ivan',
    name: '👤 Ivan (Admin)',
    token:
      'eyJwcm9maWxlSWQiOiI2YmQ0Nzc5Ni1mZGZkLTQ4OTktYjI2MC01MDZjNmZmYjI5ZGEiLCJzZXNzaW9uSWQiOiJmMThiYTllZS1iYzc2LTQ0YjctYmRkZC01NzA3NzY2MWZhMzEiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiIyZWY0MTM5NS1hMTU2LTQyOTItYWI1NC1hMTg0ZmY3YWFkYjIiLCJyb2xlcyI6WzFdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
  {
    key: 'maria',
    name: '👤 Maria',
    token:
      'eyJwcm9maWxlSWQiOiJhNjgwOGZjZS1jZDk5LTQ2NjgtYTI3My1hNDU0MmY1N2I4MjIiLCJzZXNzaW9uSWQiOiJiMjExMWNjMS00N2IxLTRiMGYtYjc3MC0wZmM2NjU1N2U5YTUiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiI5YTFjYjc1ZS05ZWQ4LTQ2MTQtYjgwNi0zZGQ0MmRiZDcxNTAiLCJyb2xlcyI6WzJdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
  {
    key: 'leonid',
    name: '👤 Leonid',
    token:
      'eyJwcm9maWxlSWQiOiIzODU2NGM5ZC03NmQ2LTQ0YzUtYjRiZC1jOGYyMzM5NWM3MDQiLCJzZXNzaW9uSWQiOiJkY2Q1NTNkNi02YWNlLTQ2ZWUtYTc2YS02ODMyOTk4ZGE1NmUiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiI1Y2UwNDQwYi05ZWQyLTQ2ZWItYmEyNi05NTkzMmIzZmMwODkiLCJyb2xlcyI6WzJdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
  {
    key: 'artem',
    name: '👤 Artem',
    token:
      'eyJwcm9maWxlSWQiOiJkN2NjNGQ2Yi04YTMzLTRkY2MtYWMxZS02ODk5MzU5YjFhMTkiLCJzZXNzaW9uSWQiOiIxNjRkM2Q0NC1mYjZlLTQ0NWQtYWUwZi00ZTBlMGViMTNhNjYiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiJlYjRiNzA2Yy1kM2NhLTQ5NjgtOWYxMi0yMTA3MmEwNGM3OWUiLCJyb2xlcyI6WzJdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
  {
    key: 'alina',
    name: '👤 Alina',
    token:
      'eyJwcm9maWxlSWQiOiI0NWZkZTU4Mi1iOWU1LTQyYjItYTNkNi03ZDRmNTU4MzNiYjMiLCJzZXNzaW9uSWQiOiI1MGQ2NDk4NC0zODE3LTRmOTEtYjIwNy03NzUyOWI0MWE2NGUiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiI1N2JiZGNiMy04ZTdhLTQ3ZTItYjQ5ZS1mOTg1Mjk1MmMwM2EiLCJyb2xlcyI6WzJdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
  {
    key: 'dima',
    name: '👤 Dima',
    token:
      'eyJwcm9maWxlSWQiOiI5MDcwMzg0MS0zMzBlLTQxNzgtODFmYi1jMjdlMDBiMDI5OTgiLCJzZXNzaW9uSWQiOiI3YmRmNmVjNC1iNjJmLTQwNGUtOGUwYS0zZWE5YjQ1NjNiMTMiLCJ3b3Jrc3BhY2VzIjp7ImE3ZGZlN2MwLThlNTAtNGI2YS04NDc4LTBiMWYzZTUzNWQ4NiI6eyJ1c2VySWQiOiI0YzVkN2NjNi1kODcwLTRmYzMtYmRhOS1hODViMzU0ZjE2OTciLCJyb2xlcyI6WzJdfX0sImdyYW50ZWRUaW1lIjoiMjAyNS0wOS0zMFQwMDowMDowMC4wMDBaIn0=',
  },
];

export const DEFAULT_DEV_TOKEN = DEV_TOKENS[0];
